interface IStateOfOperations {
  type: string;
  stateOfOperations: string | null;
}

const stateOfOperations = (state = null, action: IStateOfOperations) => {
  switch (action.type) {
    case 'SET_STATE_OF_OPERATIONS':
      return action.stateOfOperations
    default:
      return state
  }
}

export default stateOfOperations;